import { render, staticRenderFns } from "./ReasonManager.vue?vue&type=template&id=c5148164&scoped=true"
import script from "./ReasonManager.vue?vue&type=script&lang=ts"
export * from "./ReasonManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5148164",
  null
  
)

export default component.exports